import HeaderActionTypes from "./header.types";

const INITIAL_STATE = {
  header: [],
  isFetching: false,
  isLoaded: false,
  errorMessage: undefined,
};

const HeaderReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case HeaderActionTypes.FETCH_HEADER_REQUEST:
      return { ...state, isFetching: true, isLoaded: false };

    case HeaderActionTypes.FETCH_HEADER_FULFILLED:
      return {
        ...state,
        header: action.payload,
        isFetching: false,
        isLoaded: true,
      };

    case HeaderActionTypes.FETCH_HEADER_REJECTED:
      return {
        ...state,
        errorMessage: action.payload,
        isFetching: false,
        isLoaded: false,
      };
    case HeaderActionTypes.FETCH_UPDATE_HEADER_SUCCESS:
      return {
        ...state,
        header: [action.payload],
        isFetching: false,
        isLoaded: true,
      };

    case HeaderActionTypes.FETCH_UPDATE_HEADER_FAILED:
      return {
        ...state,
        errorMessage: action.payload,
        isFetching: false,
        isLoaded: false,
      };
    default:
      return state;
  }
};

export default HeaderReducer;
